<content>
  <section id="big-modal" >
  <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
    <div class="info">{{'global.infoRequired' | translate}}</div>
    <div class="entry-4-modal">
      <label>{{'usuarios.productor.modal.nombre' | translate}} *</label>
      <input type="email" formControlName="nombre">
    </div>
    <div class="entry-4-modal" *ngIf="!productorId">
      <label>{{'usuarios.productor.modal.denominacion' | translate}} *</label>
      <app-filterable-list [ngClass]="role === 'Auditor' ? 'short-list' : ''" [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacion')" [placeHolder]="false"></app-filterable-list>
    </div>
    <div class="entry-4-modal" *ngIf="!productorId">
      <label>{{'global.pais' | translate}} *</label>
      <app-filterable-list [ngClass]="role === 'Auditor' ? 'short-list' : ''" [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [disabled]="disabledPais" [placeHolder]="false"></app-filterable-list>
    </div>
    <div class="entry-4-modal">
      <label>{{'usuarios.productor.modal.paisProductor' | translate}} *</label>
      <app-filterable-list [ngClass]="role === 'Auditor' ? 'short-list' : ''" [itemsList]="paisesProductor" [selectedItem]="newEditForm.get('paisProductor')" [placeHolder]="false"></app-filterable-list>
    </div>
    <div class="entry-4-modal">
      <label>{{'usuarios.productor.modal.provinciaProductor' | translate}} *</label>
      <app-filterable-list [ngClass]="role === 'Auditor' ? 'shorter-list' : ''" [itemsList]="provinciasProductor" [selectedItem]="newEditForm.get('provinciaProductor')" [disabled]="disabledProvinciaProductor" [placeHolder]="false"></app-filterable-list>
    </div>
    <div class="entry-4-modal">
      <label>{{'usuarios.productor.modal.municipioProductor' | translate}} *</label>
      <app-filterable-list [ngClass]="role === 'Auditor' ? 'shorter-list' : ''" [itemsList]="municipiosProductor" [selectedItem]="newEditForm.get('municipioProductor')" [disabled]="disabledMunicipioProductor" [placeHolder]="false"></app-filterable-list>
    </div>
    <div class="entry-4-modal" *ngIf="this.role === 'Administrador'">
      <label>{{'usuarios.productor.modal.direccion' | translate}}</label>
      <input type="text" formControlName="direccion">
    </div>
    <div class="entry-4-modal">
      <label>{{'usuarios.productor.modal.nif' | translate}}</label>
      <input type="text" formControlName="nifcif">
    </div>
    <div class="entry-4-modal" *ngIf="!productorId && this.role === 'Administrador'">
      <label>{{'usuarios.productor.modal.telefono' | translate}}</label>
      <input type="text" formControlName="telefono">
    </div>
    <div class="entry-4-modal">
      <label>{{'usuarios.productor.modal.contacto' | translate}}</label>
      <input type="text" formControlName="personaContacto">
    </div>
    <div class="entry-4-modal" *ngIf="!productorId && this.role === 'Administrador'">
      <label>{{'usuarios.productor.modal.idioma' | translate}} *</label>
      <app-filterable-list [itemsList]="idiomas" [selectedItem]="newEditForm.get('idioma')" [placeHolder]="false">
      </app-filterable-list>
    </div>
    <h3 *ngIf="this.role === 'Administrador'">{{'usuarios.productor.modal.datosUsuario' | translate}}</h3>
    <div class="entry-4-modal" *ngIf="!productorId && this.role === 'Administrador'">
      <label>{{'usuarios.productor.modal.userName' | translate}}</label>
      <input type="email" formControlName="userName">
    </div>
    <div class="entry-4-modal" *ngIf="!productorId && this.role === 'Administrador'">
      <label>{{'usuarios.productor.modal.password' | translate}}</label>
      <input type="text" formControlName="password">
    </div>
    <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
      <input type="checkbox" id="dobleFactor" formControlName="dobleFactor">
      <label for="dobleFactor">{{'usuarios.productor.modal.dobleFactor' | translate}}</label>
    </div>
  </form>
  </section>
</content>
<footer class="button-bar-right">
  <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
  <button (click)="save()">{{productorId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
